import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_WHD_STMT_REQUEST = 'GET_WHD_STMT_REQUEST';
export const GET_WHD_STMT_SUCCESS = 'GET_WHD_STMT_SUCCESS';
export const GET_WHD_STMT_FAILURE = 'GET_WHD_STMT_FAILURE';
export const RESET_WHD_STMT_LIST = 'RESET_WHD_STMT_LIST';
export const RESET_ACCOUNT_WHS_LINKING = 'RESET_ACCOUNT_WHS_LINKING';

function requestGetWhdStatement(accountId) {
  return {
    type: GET_WHD_STMT_REQUEST,
    isGettingStatement: true,
    accountId
  };
}

function receiveGetWhdStatement(accountId, statementContainer) {
  return {
    type: GET_WHD_STMT_SUCCESS,
    isGettingStatement: false,
    accountId,
    statementContainer
  };
}

function rejectGetWhdStatement(accountId) {
  return {
    type: GET_WHD_STMT_FAILURE,
    isGettingStatement: false,
    accountId
  };
}

function resetWhdStatementList() {
  return {
    type: RESET_WHD_STMT_LIST
  };
}

export function resetIsWhsLinkingActive() {
  return {
    type: RESET_ACCOUNT_WHS_LINKING,
    isWhsLinkingActive: false
  };
}

export function getWhdStatement(accountId, versionNumber) {
  return (dispatch) => {
    dispatch(requestGetWhdStatement(accountId));
    let promise = null;
    const apiCall = !versionNumber ? ApiService.getAccountWithholdingStatement : ApiService.getAccountWithholdingStatementVersion;
    promise = () => apiCall(accountId, versionNumber)
      .then((response) => {
        dispatch(receiveGetWhdStatement(accountId, response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(rejectGetWhdStatement(accountId));
          dispatch(handleException(error, null, true));
        }
      });
    return promise();
  };
}

export function resetAccountWhdStatementList() {
  return dispatch => dispatch(resetWhdStatementList());
}
